"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = require("@fluentui/react");
var react_redux_1 = require("react-redux");
var clsx_1 = __importDefault(require("clsx"));
var reducers_1 = require("../../reducers");
require("./CustomDialog.scss");
var connector = react_redux_1.connect(reducers_1.ComponentEtaMapStateToProps);
var CustomDialog = function (props) {
    var currentLang = props.currentLang, maxWidthProps = props.maxWidth, subTextProps = props.subText, titleProps = props.title, dialogContentProps = props.dialogContentProps, modalProps = props.modalProps, hidden = props.hidden, children = props.children, Footer = props.Footer, loadingText = props.loadingText;
    var className = clsx_1.default(currentLang.isRtl ? 'rtlFlag' : 'ltrFlag');
    var modalPropsStyles = {
        main: { maxWidth: maxWidthProps, class: className },
    };
    var internalDialogContentProps = __assign({ type: react_2.DialogType.normal, title: titleProps, subText: subTextProps }, dialogContentProps);
    react_1.useEffect(function () {
        react_2.setRTL(props.currentLang.isRtl);
    }, [currentLang.isRtl]);
    var internalModalProps = react_1.default.useMemo(function () {
        var _a;
        return ({
            isBlocking: true,
            styles: __assign(__assign({}, modalPropsStyles), (_a = props.modalProps) === null || _a === void 0 ? void 0 : _a.styles),
            dragOptions: undefined,
        });
    }, [modalPropsStyles]);
    return (react_1.default.createElement(react_2.Dialog, __assign({}, props, { className: "eta-dialog", hidden: hidden, onDismiss: function () {
            if (!loadingText) {
                props.onDismiss();
            }
        }, dialogContentProps: internalDialogContentProps, modalProps: __assign(__assign({}, internalModalProps), modalProps) }),
        loadingText && (react_1.default.createElement("div", { className: 'eta-dialogLoadingContainer' },
            react_1.default.createElement(react_2.Spinner, { size: 3, title: 'loading' }),
            react_1.default.createElement("span", null, loadingText))),
        children,
        react_1.default.createElement(react_2.DialogFooter, { className: className }, Footer)));
};
CustomDialog.defaultProps = {
    subText: undefined,
    Footer: undefined,
    loadingText: undefined
};
exports.default = connector(CustomDialog);
//# sourceMappingURL=CustomDialog.js.map